export const CSRF_TOKEN = 'Csrf-Token';
export const X_CITRIX_ISUSINGHTTPS = 'X-Citrix-IsUsingHTTPS';
export const X_REQUESTED_WITH = 'X-Requested-With';
export const X_CITRIX_APPPROTECTION = 'X-Citrix-AppProtection-Capable';
export const CITRIX_IGNORE_AUTH_CHALLENGE = 'Citrix-Ignore-Auth-Challenge';
export const X_CLOUD_OFFLINE_REQUEST = 'X-CLOUD-OFFLINE-REQUEST';
export const X_CITRIX_WSUI_SESSION_ID = 'X-Citrix-WSUI-Session-Id';
export const CITRIX_CLIENT_URL = 'Citrix-Client-Url';
export const X_CITRIX_LAUNCH_TYPE = 'X-Citrix-Launch-Type';
export const X_CITRIX_LAUNCH_TYPE_CHROME_VALUE = 'chrome';
